import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  name: 'signup',
  namespaced: true,
  state: {
    company: {
      name: null,
      businessNumber: null,
    },
    signUpErrorRecords: [],
  },
  mutations: {
    setCompany(state, company) {
      state.company = company
    },
    setSignUpErrorRecords(state, signUpErrorRecords) {
      state.signUpErrorRecords = signUpErrorRecords
    },
  },
  getters: {
    signUpErrorRecordsPending(state) {
      return state.signUpErrorRecords.find(
        (record) => ['canceled', 'completed'].includes(record.status) === false,
      )
    },
  },
  actions: {
    async getUserCheckDuplication({}, params) {
      const {
        data: { exists },
      } = await defaultApi.getUsersCheckDuplication(params)
      return exists
    },
    async addUsersSignUpErrorRecords({}, params) {
      defaultApi.postUsersSignUpErrorRecords(params)
    },
    async getUsersSignUpErrorRecords({ commit }) {
      const { data } = await defaultApi.getUsersSignUpErrorRecords()
      commit('setSignUpErrorRecords', data)
      return data
    },
  },
}
